import i18n from 'scoreboard/components/i18n'
import SuccessDialog from 'scoreboard/components/success-dialog'

const BroadcastAlertConfirmation = SuccessDialog.extend({
	context: function () {
		return {
			title: i18n.get('admin.alertPreferences.broadcast.confirmation.title')
		}
	}
})

export default BroadcastAlertConfirmation
BroadcastAlertConfirmation.__filename__ = 'admin/alerts/broadcast-alert-confirmation.js'
